import React from 'react';
import Layout from '../common/Layout';
import ScoreCard from './ScoreCard';
import TabNavigation from './TabNavigation';
import { FoodRecommendationsTab } from './FoodRecommendationsTab';
import HospitalsTab from './HospitalsTab';
import ReelsTab from './ReelsTab';
import { useRecommendations } from './useRecommendations';
import { useTranslation } from 'react-i18next';

const RecommendationsScreen: React.FC = () => {
  const {
    session,
    score,
    activeTab,
    setActiveTab
  } = useRecommendations();
  const { t } = useTranslation();
  
  return (
    <Layout title={t('recommendations')} showBackButton={false}>
      <div className="pb-20 animate-fade-in">
        <div className="mb-6">
          <ScoreCard score={score} />
        </div>
        
        <div className="mb-6">
          <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
          
          {activeTab === 'food' && <FoodRecommendationsTab />}
          {activeTab === 'hospitals' && <HospitalsTab />}
          {activeTab === 'reels' && <ReelsTab session={session} />}
        </div>
      </div>
    </Layout>
  );
};

export default RecommendationsScreen;
